import { configureStore } from "@reduxjs/toolkit";
import auth from "./slices/authSlice";
import account from "./slices/accountSlice";
import accountBalance from "./slices/accountBalanceSlice";
import handicapper from "./slices/handicapperSlice";
import dailyFigure from "./slices/dailyFigureSlice";
import dailyFigureSearch from "./slices/dailyFigureSearchSlice";
import manager from "./slices/managerSlice";
import bettor from "./slices/bettorSlice";
import agent from "./slices/agentSlice";
import bet from "./slices/betSlice";
import arbitrageBet from "./slices/arbitrageBetSlice";

const store = configureStore({
  reducer: {
    auth: auth,
    account: account,
    accountBalance: accountBalance,
    handicapper: handicapper,
    dailyFigure: dailyFigure,
    dailyFigureSearch: dailyFigureSearch,
    manager: manager,
    bettor: bettor,
    agent: agent,
    bet: bet,
    arbitrageBet: arbitrageBet,
  },
});

export default store;
